// region import React
import React from 'react'
import { Waypoint } from 'react-waypoint'
import {
  AnnotationCallout,
  AnnotationCalloutCircle,
  AnnotationBracket,
  AnnotationLabel
} from 'react-annotation'
import GraphLeft from './GraphLeft'
import GraphRight from './GraphRight'

class App extends React.Component {
  /**
   * Define default prop values.
   * Used for the initial render of the component.
   */
  static defaultProps = {}

  /** Default state */
  state = {
    layout: 'toRandom',
    step: -1,
    scale: 1,
    hideTop: ''
  }

  /**
   * Called once the component has been mounted.
   */
  componentDidMount() {}

  toggleTop() {
    const oldClassName = this.state.hideTop
    const newClassName = oldClassName === '' ? 'hiddenTitle' : ''
    this.setState({
      hideTop: newClassName
    })
  }

  /**
   * Called whenever the component needs to be rendered again.
   */
  render() {
    return (
      <div className='ui vertical segment' id='stickyContainer'>
        <div className='left ui rail' id='stickyLeft'>
          {/* <div className="ui segment" style={{width: "300px", height: "800px", left: "100px"}}> */}
          {/* <h4 className="ui header">Einkommensgruppen</h4> */}
          <GraphLeft layout={this.state.layout} layoutLvl={this.state.step} />
          <svg
            viewBox='0,0,250,600'
            style={{ position: 'absolute', left: '0px', top: '0px' }}
          >
            {/* {this.state.step === 0 ? (
              <AnnotationCallout
                x={100}
                y={500}
                dy={-165}
                dx={10}
                color={'#000000'}
                className='show-bg'
                editMode={false}
                note={{
                  title: 'Max.  Reineinkommen: 52 000 Fr.',
                  label:
                    'Die untere Hälfte, das sind 2,5 Millionen Steuerpflichtige, versteuert 7.7 % des Einkommens.',
                  lineType: null,
                  bgPadding: { top: 15, left: 10, right: 0, bottom: 0 },
                  padding: 0,
                  titleColor: '#000000'
                }}
                connector={{ type: 'curve', end: 'dot' }}
              />
            ) : null} */}
            {/* {this.state.step === 1 ? (
              <AnnotationLabel
                x={140}
                y={385}
                dy={-20}
                dx={20}
                color={'#000'}
                className='show-bg'
                editMode={false}
                note={{
                  title: 'Max. Reineinkommen: 107 000 Fr.',
                  label:
                    'Ein Drittel der steuerpflichtigen Bevölkerung verdient jährlich zwischen 52 000 und 107 000 Franken, Steuerfuss 12,3%.',
                  align: 'middle',
                  orientation: 'topBottom',
                  bgPadding: 20,
                  padding: 15,
                  titleColor: '#000',
                  lineType: null
                }}
                connector={{ type: 'line', end: 'dot' }}
              />
            ) : null} */}
            {/* {this.state.step === 2 ? (
              <AnnotationLabel
                x={255}
                y={300}
                dy={24}
                dx={-40}
                color={'#000'}
                className='show-bg'
                editMode={false}
                note={{
                  title: 'MR: 107 000 Fr.',
                  align: 'right',
                  orientation: 'topBottom',
                  bgPadding: 0,
                  padding: 0,
                  titleColor: '#000',
                  lineType: null
                }}
                connector={{ type: 'line', end: 'dot' }}
              />
            ) : null} */}
            {/* {this.state.step === 3 ? (
              <AnnotationLabel
                x={285}
                y={200}
                dy={+13}
                dx={-80}
                color={'#000'}
                className='show-bg'
                editMode={false}
                note={{
                  title: 'MR: 322 000 Fr.',
                  align: 'right',
                  orientation: 'topBottom',
                  bgPadding: 0,
                  padding: 0,
                  titleColor: '#000',
                  lineType: null
                }}
                connector={{ type: 'line', end: 'dot' }}
              />
            ) : null} */}
            {/* {this.state.step >= 4 ? (
              <AnnotationBracket
                x={255}
                y={100}
                dy={80}
                dx={-30}
                color={'#000000'}
                editMode={false}
                note={{
                  title: 'Oberstes Prozent',
                  label: 'Diese beiden Gruppen bilden zusammen das oberste Einkommens-Prozent.'
                }}
                subject={{ height: 140, type: 'curly', depth: -20 }}
              />
            ) : null} */}
            {this.state.step >= 4 ? (
              <AnnotationCalloutCircle
                x={244}
                y={118}
                dy={-40}
                dx={-80}
                color={'#000000'}
                editMode={false}
                note={{
                  label: '500 Steuerzahler',
                  padding: 0,
                  lineType: null
                }}
                connector={{ type: 'elbow' }}
                subject={{ radius: 5, radiusPadding: 5 }}
              />
            ) : null}
            {this.state.step === 3 ? (
              <AnnotationCalloutCircle
                x={244}
                y={182}
                dy={-10}
                dx={-80}
                color={'#000000'}
                editMode={false}
                note={{
                  label: 'Ein Punkt entspricht ca. 0.1% der Steuerzahler',
                  padding: 0,
                  lineType: null,
                  align: 'middle',
                  orientation: 'leftRight'
                }}
                connector={{ type: 'line' }}
                subject={{ radius: 5, radiusPadding: 5 }}
              />
            ) : null}
            {/* {this.state.step >= 4 ? (
              <AnnotationLabel
                x={283}
                y={118}
                dy={+90}
                dx={-70}
                color={'#000000'}
                className='show-bg'
                editMode={false}
                note={{
                  title: ' Minimales Reineinkommen (MR): 4,3 Mio. Fr.',
                  label:
                    'Das Reineinkommen berechnet sich aus dem Nettoeinkommen minus «zusätzliche Abzüge» wie Krankheitskosten oder gemeinnützige Zuwendungen.',
                  align: 'right',
                  orientation: 'topBottom',
                  bgPadding: 0,
                  padding: 0,
                  titleColor: '#000000'
                }}
                connector={{ type: 'line' }}
              />
            ) : null} */}
          </svg>
          {/* </div> */}
        </div>
        <div className='right ui rail' id='stickRight'>
          {/* <div className="ui sticky" style={{width: "272px", height: "262.531px", left: "215px;"}}> */}
          <GraphRight layout={this.state.layout} layoutLvl={this.state.step} />
          <svg
            viewBox='0,0,250,600'
            style={{ position: 'absolute', left: '0px', top: '0px' }}
          >
            {this.state.step <= 0 ? (
              <AnnotationCallout
                x={50}
                y={500}
                dy={+20}
                dx={+55}
                color={'#000000'}
                className='show-bg'
                editMode={false}
                note={{
                  label: 'Zusammen tragen sie 10.79 % der Steuerlast.',
                  lineType: null,
                  bgPadding: { top: 15, left: 10, right: 0, bottom: 0 },
                  padding: 0,
                  titleColor: '#000000'
                }}
                connector={{ type: 'elbow', end: 'dot' }}
              />
            ) : null}
            {this.state.step === 1 ? (
              <AnnotationLabel
                x={150}
                y={455}
                dy={+30}
                dx={10}
                color={'#000'}
                className='show-bg'
                editMode={false}
                note={{
                  label: 'Beitrag zum Steuerertrag: 35%',
                  align: 'middle',
                  orientation: 'topBottom',
                  bgPadding: 20,
                  padding: 15,
                  titleColor: '#000',
                  lineType: null
                }}
                connector={{ type: 'line', end: 'dot' }}
              />
            ) : null}
            {this.state.step === 3 ? (
              <AnnotationBracket
                x={105}
                y={50}
                dy={70}
                dx={20}
                color={'#000000'}
                editMode={false}
                note={{
                  label: '1% Superverdiener zahlt 24% aller Einkommenssteuern',
                  align: 'bottom'
                }}
                subject={{ height: 190, type: 'curly', depth: 20 }}
              />
            ) : null}
            {this.state.step >= 4 ? (
              <AnnotationLabel
                x={25}
                y={50}
                dy={+5}
                dx={60}
                color={'#000'}
                className='show-bg'
                editMode={false}
                note={{
                  label:
                    'Die 500 Super- verdiener tragen 4,45% der Steuerlast (insgesamt 2,3 Mrd. Fr.)',
                  align: 'left',
                  orientation: 'topBottom',
                  bgPadding: 0,
                  padding: 0,
                  titleColor: '#000',
                  lineType: null
                }}
                connector={{ type: 'line', end: 'dot' }}
              />
            ) : null}
          </svg>
          {/* </div> */}
        </div>
        <div className='ui text container' id='appText'>
          <Waypoint
            scrollableAncestor={window}
            onEnter={() => {
              this.setState({
                layout: 'toGrid',
                step: 4
              })
            }}
          />
          <p className='textBox'>
            Die 500 bestverdienenden Schweizer haben ein Reineinkommen
            (Begriffserklärung am Ende des Beitrags) von je mindestens 4,3
            Millionen Franken. Sie zahlen zusammen 2,3 Milliarden Franken
            Einkommenssteuern. Eine Kleinstminderheit von Superverdienern, nur{' '}
            <b>0,01 Prozent</b> aller Steuerpflichtigen, trägt also{' '}
            <b>4,45 Prozent</b> der Steuerlast. Ihre Steuerbelastung beträgt
            durchschnittlich 38 Prozent.
          </p>
          <Waypoint
            scrollableAncestor={window}
            onEnter={() => {
              this.setState({
                layout: 'toGrid',
                step: 3
              })
            }}
          />
          <p className='textBox'>
            Das <b>bestverdienende ein Prozent</b> der Steuerpflichtigen zahlt
            knapp <b>ein Viertel</b> der gesamten Einkommenssteuer. Das sind
            50'000 Grossverdiener mit einem Reineinkommen zwischen 322'000 und
            4,3 Millionen Franken. Gemeinsam bezahlen sie 12,5 Milliarden
            Franken, durchschnittlich 245'866 Franken pro Kopf.
          </p>
          <Waypoint
            scrollableAncestor={window}
            onEnter={event => {
              this.setState({
                layout: 'toGrid',
                step: 2
              })
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  eventAction: 'vertical-scroll',
                  eventLabel: '25ContentRead'
                })
              }
            }}
          />
          <p className='textBox'>
            Die einkommensstärksten <b>10 Prozent</b> der Steuerpflichtigen
            bezahlen <b>mehr als die Hälfte</b>, nämlich 53 Prozent der
            Einkommenssteuern. Das sind 500'000 Personen mit einem Reineinkommen
            zwischen 107'000 und 322'000 Franken. Sie steuern zusammen 27,9
            Milliarden Franken bei. Der durchschnittliche Steuerbeitrag pro Kopf
            beträgt 55'113 Franken.
          </p>
          <Waypoint
            scrollableAncestor={window}
            onEnter={() => {
              this.setState({
                layout: 'toGrid',
                step: 1
              })
            }}
          />
          <p className='textBox'>
            Die <b>Schweizer Mittelschicht</b> &ndash; 2 Millionen
            Steuerpflichtige mit einem Reineinkommen von 52'000 bis 107'000
            Franken &ndash; bezahlt 18,6 Milliarden Franken. Das sind 40 Prozent
            der Steuerpflichtigen, die <b>35,6 Prozent der Steuern</b> bezahlen.
            Durchschnittlich beträgt der Beitrag 9154 Franken pro Kopf. Ihre
            Steuerbelastung liegt bei 12,3 Prozent.
          </p>
          <Waypoint
            scrollableAncestor={window}
            onEnter={() => {
              this.setState({
                layout: 'toGrid',
                step: 0
              })
            }}
          />
          <p className='textBox'>
            Die <b>untere Hälfte</b> bezahlt zusammen 5,6 Milliarden Franken.
            Das sind 2,5 Millionen Steuerpflichtige mit weniger als 52'000
            Franken Reineinkommen. Sie tragen zusammen{' '}
            <b>11 Prozent aller Steuern</b>. Durchschnittlich beträgt der
            Steuerbeitrag 1109 Franken pro Kopf. Ihre Steuerbelastung liegt bei
            7,7 Prozent.
          </p>
          <Waypoint
            scrollableAncestor={window}
            onEnter={() => {
              this.setState({
                layout: 'toGrid',
                step: -1
              })
              this.toggleTop()
            }}
            onLeave={() => {
              this.toggleTop()
            }}
          />
        </div>
      </div>
    )
  }
}

export default App
